export const atributos_options = [
    { label: 'Nombre', value: 'nombre' },
    { label: 'Apellido', value: 'apellido' },
    { label: 'Documento', value: 'documento' },
    { label: 'Razón Social', value: 'razonSocial' },
    { label: 'Matricula', value: 'matricula' },
    { label: 'Tipo de Informe', value: 'tipo' },
    { label: 'Partido', value: 'partido' },
    { label: 'Patente', value: 'patente' },
    { label: 'Entrada', value: 'entrada' }
]
